/**
 * Variant dropdown scroll bar.
 *
 * iOS Safari never paints a resting scroll bar for an overflow container: it
 * ignores ::-webkit-scrollbar and its own indicator is a transient overlay that
 * only appears mid-gesture. So an iPhone customer got no cue that a variant
 * list held more options than the two-and-a-half rows on screen.
 *
 * The native bar is therefore hidden on every platform (see main.css) and the
 * rail in the markup is driven from here, keeping all platforms identical.
 * Sizes are written as CSS custom properties so the appearance stays in CSS.
 *
 * Covers the product page and quick view from one place: it listens on the
 * document, so quick-view markup injected after load is picked up with no
 * re-initialisation.
 */
(function () {
  var SCROLLABLE_CLASS = 'custom-dropdown__options--scrollable';
  var MIN_THUMB_HEIGHT = 24;

  function updateBar(options) {
    var bar = options.querySelector('.custom-dropdown__scrollbar');
    if (!bar) return;

    var scrollHeight = options.scrollHeight;
    var clientHeight = options.clientHeight;
    var isScrollable = scrollHeight - clientHeight > 1;

    options.classList.toggle(SCROLLABLE_CLASS, isScrollable);
    if (!isScrollable) return;

    var thumbHeight = Math.max(
      MIN_THUMB_HEIGHT,
      (clientHeight / scrollHeight) * clientHeight
    );
    var progress = options.scrollTop / (scrollHeight - clientHeight);
    var thumbTop = progress * (clientHeight - thumbHeight);

    bar.style.setProperty('--dropdown-track-height', clientHeight + 'px');
    bar.style.setProperty('--dropdown-thumb-height', thumbHeight + 'px');
    bar.style.setProperty('--dropdown-thumb-top', thumbTop + 'px');
  }

  function updateOpenBars() {
    var open = document.querySelectorAll('.custom-dropdown.open .custom-dropdown__options');
    Array.prototype.forEach.call(open, updateBar);
  }

  // Capture, because scroll does not bubble. e.target can be the document
  // itself, which has no classList, so guard before touching it.
  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      if (target.classList.contains('custom-dropdown__options')) updateBar(target);
    },
    true
  );

  // A click is what opens a dropdown and what swaps the selected option, and
  // the existing dropdown code toggles .open synchronously. Measure on the next
  // frame, once that class change has been laid out.
  document.addEventListener(
    'click',
    function () {
      requestAnimationFrame(updateOpenBars);
    },
    true
  );

  window.addEventListener('resize', updateOpenBars);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateOpenBars);
  } else {
    updateOpenBars();
  }
})();
